import { Box } from "@mui/material";

const ACCENT = "#125CC7";

// Drag handle for the left edge of a right-anchored, resizable MUI Drawer.
// Purely presentational + keyboard support; all state/math/persistence lives
// in useResizableDrawerWidth. Spread its handleProps directly onto this.
// Renders nothing when `enabled` is false (e.g. below the drawer's desktop
// breakpoint) — there is no edge to drag on a full-viewport mobile drawer.
const DrawerResizeHandle = ({
  enabled = true,
  width,
  minWidth,
  maxWidth,
  isDragging,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
  onKeyDown,
  ariaLabel = "Resize drawer width",
}) => {
  if (!enabled) return null;
  return (
    <Box
      role="separator"
      aria-orientation="vertical"
      aria-label={ariaLabel}
      aria-valuenow={Math.round(width)}
      aria-valuemin={Math.round(minWidth)}
      aria-valuemax={Math.round(maxWidth)}
      tabIndex={0}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
      onKeyDown={onKeyDown}
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        // Fully inside the Paper's own box, not straddling it with a negative
        // offset: the Paper's overflowY:"auto" forces overflowX to compute to
        // "auto" too, so anything placed outside the left edge would clip.
        left: 0,
        width: "8px",
        cursor: "col-resize",
        touchAction: "none", // stop touch browsers hijacking this as a scroll gesture
        zIndex: 1,
        backgroundColor: isDragging ? `${ACCENT}47` : "transparent",
        "&:hover": { backgroundColor: `${ACCENT}29` },
        "&:focus-visible": {
          outline: `2px solid ${ACCENT}`,
          outlineOffset: "-2px",
          backgroundColor: `${ACCENT}29`,
        },
      }}
    />
  );
};

export default DrawerResizeHandle;
